import initHeader from './layout/header';
import initCommerce from './components/commerce';
import initHomeHero from './components/home-hero';
import initProductDetail from './components/product-detail';
import initClientLogos from './components/client-logos';
import initRegistrationParallax from './components/registration-parallax';
import initCustomerRegistration from './components/customer-registration';
import initSocialLinks from './components/social-links';

import initProductSearch from './components/product-search';
import initProductCategory from './components/product-category';

document.addEventListener('DOMContentLoaded', function () {
  initHeader();
  initCommerce();
  initHomeHero();
  initProductDetail();
  initProductSearch();
  initProductCategory();
  initClientLogos();
  initRegistrationParallax();
  initCustomerRegistration();
  initSocialLinks();
});
